import React from 'react';
import { Redirect } from 'react-router-dom';
import WarrantyFaultGroupPage from 'pages/WarrantyManagement/WarrantyFaultGroupPage';
import WarrantyPeriodPage from 'pages/WarrantyPeriod/WarrantyPeriodPage';
import WarrantyPeriodAddPage from 'pages/WarrantyPeriod/WarrantyPeriodAddPage';
import WarrantyPeriodLegacyRedirect from 'pages/WarrantyPeriod/WarrantyPeriodLegacyRedirect';
import WarrantyWorkflowConfigPage from 'pages/WarrantyManagement/WarrantyWorkflowConfigPage';
import WarrantyWorkflowPages from 'pages/WarrantyManagement/WarrantyWorkflowPages';
import WarrantyTypePage from 'pages/WarrantyManagement/WarrantyTypePage';
import WarrantyDismantlePage from 'pages/WarrantyDismantle/WarrantyDismantlePage';

const WarrantyWorkflowLegacyRedirect = () => <Redirect to='/warranty-types' />;

const warrantyPeriodRoute = [
  { path: '/warranty-dismantle', exact: true, name: 'Tách máy lấy linh kiện', function: 'SL_WARRANTY_DISMANTLE_VIEW', requireAssigned: true, component: WarrantyDismantlePage },
  { path: '/warranty-workflows', exact: false, name: 'Hình thức bảo hành', function: 'MD_WARRANTYTYPE_VIEW', component: WarrantyWorkflowLegacyRedirect },
  { path: '/warranty-package', exact: true, name: 'Danh mục gói bảo hành', function: 'MD_WARRANTYPERIOD_VIEW', component: WarrantyPeriodPage },
  { path: '/warranty-package/add', exact: true, name: 'Thêm mới gói bảo hành', function: 'MD_WARRANTYPERIOD_ADD', component: WarrantyPeriodAddPage },
  { path: '/warranty-package/edit/:warranty_package_id', exact: true, name: 'Chỉnh sửa gói bảo hành', function: 'MD_WARRANTYPERIOD_EDIT', component: WarrantyPeriodAddPage },
  { path: '/warranty-package/detail/:warranty_package_id', exact: true, name: 'Chi tiết gói bảo hành', function: 'MD_WARRANTYPERIOD_VIEW', component: WarrantyPeriodAddPage },
  { path: '/warranty-locations', exact: true, name: 'Điểm tiếp nhận & xử lý bảo hành', function: 'MD_WARRANTYTYPE_VIEW', component: WarrantyWorkflowConfigPage },
  ...['/warranty-workflow-steps'].flatMap(path=>[
    {path,exact:true,name:path.endsWith('steps')?'Bước công việc bảo hành':'Quy trình bảo hành',function:'MD_WARRANTYTYPE_VIEW',component:WarrantyWorkflowPages},
    {path:`${path}/add`,exact:true,name:path.endsWith('steps')?'Thêm bước công việc':'Thêm quy trình bảo hành',function:'MD_WARRANTYTYPE_ADD',component:WarrantyWorkflowPages},
    {path:`${path}/edit/:id`,exact:true,name:path.endsWith('steps')?'Chỉnh sửa bước công việc':'Chỉnh sửa quy trình bảo hành',function:'MD_WARRANTYTYPE_EDIT',component:WarrantyWorkflowPages},
    {path:`${path}/detail/:id`,exact:true,name:path.endsWith('steps')?'Chi tiết bước công việc':'Chi tiết quy trình bảo hành',function:'MD_WARRANTYTYPE_VIEW',component:WarrantyWorkflowPages},
  ]),
  { path: '/warranty-fault-groups', exact: true, name: 'Nhóm lỗi', function: 'MD_WARRANTYFAULT_VIEW', component: WarrantyFaultGroupPage },
  { path: '/warranty-types', exact: true, name: 'Hình thức bảo hành', function: 'MD_WARRANTYTYPE_VIEW', component: WarrantyTypePage },
  {
    path: '/warranty-period',
    exact: true,
    name: 'Danh mục gói bảo hành',
    function: 'MD_WARRANTYPERIOD_VIEW',
    component: WarrantyPeriodPage,
  },
  {
    path: '/warranty-period/add',
    exact: true,
    name: 'Thêm mới gói bảo hành',
    function: 'MD_WARRANTYPERIOD_ADD',
    component: WarrantyPeriodAddPage,
  },
  {
    path: '/warranty-period/edit/:warranty_period_id',
    exact: true,
    name: 'Chỉnh sửa gói bảo hành',
    function: 'MD_WARRANTYPERIOD_EDIT',
    component: WarrantyPeriodLegacyRedirect,
  },
  {
    path: '/warranty-period/detail/:warranty_period_id',
    exact: true,
    name: 'Chi tiết gói bảo hành',
    function: 'MD_WARRANTYPERIOD_VIEW',
    component: WarrantyPeriodLegacyRedirect,
  },
];

export default warrantyPeriodRoute;
